import { HtmlAttr, HtmlNode } from './const';
export const toYfm = {
    [HtmlNode.Block]: (state, node) => {
        state.write(node.attrs[HtmlAttr.Content]);
        state.ensureNewLine();
        state.closeBlock(node);
    },
    [HtmlNode.Inline]: (state, node) => {
        state.write(node.attrs[HtmlAttr.Content]);
    },
};
